module.exports = __webpack_public_path__ + "05_medium_black.9f6feac3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/05_medium_black.png
// module id = 0Jz+
// module chunks = 0